import PreLoading from '@/components/common/PreLoading';
import {useAppInitializer} from '@/hooks/useAppInitializer';

const AppInitializerGuard = ({children}: {children: React.ReactNode}) => {
  const isReady = useAppInitializer();

  if (!isReady) {
    return <PreLoading />;
  }

  return <>{children}</>;
};

export default AppInitializerGuard;
